import type { SectionIcon } from './types'

export const includedServicesIcons: SectionIcon[] = [
  {
    identifier: 'transfer',
    icon: 'car',
  },
  {
    identifier: 'car_with_driver',
    icon: 'driver',
  },
  {
    identifier: 'guardian',
    icon: 'securityGuard',
  },
  {
    identifier: 'villa_manager',
    icon: 'villaChaletManager',
  },
  {
    identifier: 'chalet_manager',
    icon: 'villaChaletManager',
  },
  {
    identifier: 'butler',
    icon: 'butler',
  },
  {
    identifier: 'ski_instructor',
    icon: 'ski',
  },
  {
    identifier: 'beachboys',
    icon: 'transat',
  },

  {
    identifier: 'staff_at_home',
    icon: 'homeStaff',
  },
  {
    identifier: 'chef',
    icon: 'chef',
  },
  {
    identifier: 'sports_coach',
    icon: 'sportswear',
  },
  {
    identifier: 'dinner_preparation',
    icon: 'coocking',
  },
  {
    identifier: 'tea_time',
    icon: 'teapot',
  },
  {
    identifier: 'food_shopping_on_arrival',
    icon: 'groceries',
  },
  {
    identifier: 'massage',
    icon: 'massage',
  },
  {
    identifier: 'home_fitting_of_ski_equipment',
    icon: 'homeSkiFitting',
  },
  {
    identifier: 'cook',
    icon: 'chef',
  },
]
